import * as React from "react";
const SvgIaMascot = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 40 40"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#IA_mascot_svg__a)" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M17.263 32.687c.841.452.376 1.437-.7 2.632-1.285 1.426-4.717 3.001-6.73 1.91a2.508 2.508 0 0 1-.511-.367c-1.88-1.746 5.713-4.497 6.799-4.432.512.032.888.119 1.143.257"
        fill="#5FBBE8"
      />
      <path
        d="M17.278 32.637c.812.489.37 1.539-.662 2.813-1.23 1.52-4.53 3.187-6.47 2.006 2.006-.205 5.39-1.12 7.132-4.819Z"
        fill="#5FAEDE"
      />
      <path
        d="M11.048 34.775c.553-.28 1.513-.656 1.618-.468.11.192-.667.978-1.59 1.393-.63.283-1.445.447-1.523.268-.089-.203.772-.827 1.495-1.193Z"
        fill="#B1ECED"
      />
      <path
        d="M33.239 34.94c.177 3.96-2.323 8.758-6.623 8.993-2.665.145-4.934-1.41-6.316-3.579-.85-1.33-1.366-2.892-1.435-4.435-.182-4.056 4.14-4.1 6.876-4.248 2.999-.164 6.547-.594 7.34 2.236.086.304.139.648.156 1.033"
        fill="#5FBBE8"
      />
      <path
        d="M33.244 35.03c.176 3.919-2.304 8.669-6.572 8.902-2.645.144-4.896-1.394-6.267-3.54 2.708 1.132 10.376 3.364 12.681-6.383.086.3.14.641.157 1.022"
        fill="#5FAEDE"
      />
      <path
        d="M20.385 34.179c-.53.946-.069 2.228.934 2.687 1.057.484 2.443-.078 2.78-1.174.318-1.041-.436-2.147-1.46-2.413-.82-.214-1.816.114-2.254.898"
        fill="#B1ECED"
      />
      <path
        d="M36.432 28.557c-1.085 1.443-2.062 2.094-2.68.924a3.717 3.717 0 0 1-.287-.769c-.281-1.05.945-9.054 3.063-7.568.547.384.89.95 1.076 1.61.534 1.894-.226 4.548-1.172 5.803Z"
        fill="#5FBBE8"
      />
      <path
        d="M36.711 28.825c-1.089 1.436-2.065 2.083-2.685.92.866-.547 2.423-2.13 3.858-6.692.534 1.883-.228 4.523-1.173 5.772Z"
        fill="#5FAEDE"
      />
      <path
        d="M35.215 24.441c-.305 1.21-.944 3.246-1.189 3.203-.222-.039-.155-1.772.451-3.423.338-.922.877-1.913 1.043-1.866.207.059-.21 1.71-.305 2.086Z"
        fill="#B1ECED"
      />
      <path
        d="M16.866 24.418a2.904 2.904 0 0 1-1.024-1.953 2.953 2.953 0 0 1 .132-1.195 2.75 2.75 0 0 1 1.6-1.696 2.64 2.64 0 0 1 .66-.164c.868 3.072-1.368 5.01-1.368 5.01"
        fill="#5FBBE8"
      />
      <path
        d="M16.802 24.424a2.822 2.822 0 0 1-.646-.812c.51-1.318.95-2.664 1.319-4.032.2-.08.415-.137.635-.162l-1.307 5.007"
        fill="#5FAEDE"
      />
      <path
        d="M31.99 25.554c.165 3.93-8.466 6.32-12.84 4.482-1.214-.512-2.1-1.348-2.378-2.57-1.277-5.613 1.837-11.291 6.094-11.827 1.544-.194 3.424.179 5.076 1.32 2.117 1.464 3.861 4.186 4.046 8.595"
        fill="#5FBBE8"
      />
      <path
        d="M29.44 22.5c.088.777-.694 1.358-1.74 1.78-1.102.439-2.496.7-3.475.814-1.4.161-4.128.254-5.203-.527-.254-.181-.415-.412-.447-.7a3.1 3.1 0 0 1 .103-1.204 3.15 3.15 0 0 1 2.625-2.226l4.718-.591a3.029 3.029 0 0 1 1.375.134c.443.15.848.402 1.186.735.463.465.778 1.082.858 1.785Z"
        fill="#294F81"
      />
      <path
        d="M29.44 22.547c.089.76-.687 1.333-1.72 1.744-1.091.434-2.47.69-3.438.802-1.386.16-4.084.251-5.147-.514 2.731-.426 7.34-1.461 9.458-3.784.459.455.77 1.062.848 1.752Z"
        fill="#33487A"
      />
      <path
        d="M31.991 25.57c.164 3.92-8.498 6.308-12.886 4.475 2.565.108 10.165.096 11.098-3.725.803-3.284-1.109-7.295-2.272-9.327 2.124 1.459 3.874 4.176 4.06 8.577Z"
        fill="#5FAEDE"
      />
      <path
        d="M18.71 20.15c.26.28 1.563-.54 2.41-1.369.812-.793 1.596-1.982 1.363-2.26-.209-.248-1.181.267-1.782.703-1.344.976-2.272 2.623-1.99 2.927v-.001Zm-1.351 6.344c.142 1.095.81 2.06 1.03 1.957.23-.107-.002-1.405-.187-2.111-.052-.203-.375-1.442-.622-1.403-.193.032-.314.849-.221 1.558"
        fill="#B1ECED"
      />
      <path
        d="M28.352 22.078a1.441 1.441 0 0 1-.284 1.015 1.34 1.34 0 0 1-.396.347c-.152.088-.319.143-.49.162a1.281 1.281 0 0 1-.775-.142 1.359 1.359 0 0 1-.704-1.047 1.441 1.441 0 0 1 .284-1.016c.109-.141.243-.26.395-.347.152-.087.32-.142.492-.162.253-.033.51.01.74.126a1.37 1.37 0 0 1 .737 1.064Z"
        fill="#393760"
      />
      <path
        d="M26.808 20.342c-.04.002-.08.004-.121.011-.46.057-.872.296-1.16.67a1.808 1.808 0 0 0-.178 1.927c.167.32.421.58.73.746.31.166.661.23 1.007.185a1.72 1.72 0 0 0 1.159-.67c.218-.282.348-.627.372-.988a1.801 1.801 0 0 0-.242-1.028 1.754 1.754 0 0 0-.67-.652 1.662 1.662 0 0 0-.897-.201Zm.01.258a1.462 1.462 0 0 1 1.34.732 1.537 1.537 0 0 1 .141 1.222 1.56 1.56 0 0 1-.29.549 1.48 1.48 0 0 1-.477.38 1.46 1.46 0 0 1-1.96-.657 1.54 1.54 0 0 1-.099-1.146c.06-.201.159-.388.29-.547.132-.16.294-.29.476-.382.181-.092.378-.143.58-.151Z"
        fill="#46AED2"
      />
      <path
        d="M28.319 21.331c-.376 1.424-1.685 1.552-2.47 1.493a1.58 1.58 0 0 1-.153-.524 1.561 1.561 0 0 1 .288-1.11c.232-.316.574-.523.95-.577.274-.034.55.015.796.143.245.127.45.327.587.575"
        fill="#2F4572"
      />
      <path
        d="M26.727 21.551a.43.43 0 0 1-.086.305.403.403 0 0 1-.265.152.383.383 0 0 1-.292-.082.418.418 0 0 1 .052-.683.383.383 0 0 1 .148-.05.383.383 0 0 1 .292.083.418.418 0 0 1 .15.275Zm1.602.629c.08.038.032.512-.287.73-.284.194-.698.127-.717.044-.014-.062.192-.105.515-.35.34-.256.433-.451.489-.424Z"
        fill="#B1ECED"
      />
      <path
        d="M22.248 22.67a1.442 1.442 0 0 1-.284 1.015 1.34 1.34 0 0 1-.395.347c-.152.087-.32.142-.491.162a1.282 1.282 0 0 1-.775-.143 1.36 1.36 0 0 1-.704-1.046 1.442 1.442 0 0 1 .285-1.016c.11-.142.244-.26.396-.347a1.28 1.28 0 0 1 .491-.162c.254-.033.511.01.741.125a1.352 1.352 0 0 1 .736 1.065Z"
        fill="#393760"
      />
      <path
        d="M20.708 20.933c-.04.002-.081.004-.121.01a1.72 1.72 0 0 0-1.16.671 1.806 1.806 0 0 0-.18 1.927c.167.32.422.58.732.746.31.166.66.23 1.007.184a1.703 1.703 0 0 0 1.15-.662 1.86 1.86 0 0 0 .37-1.318 1.772 1.772 0 0 0-.901-1.357 1.661 1.661 0 0 0-.897-.201Zm.013.258a1.455 1.455 0 0 1 1.336.731c.105.177.174.38.198.6.022.21.003.421-.057.623-.06.201-.16.388-.29.548a1.48 1.48 0 0 1-.476.381 1.462 1.462 0 0 1-1.96-.656 1.539 1.539 0 0 1-.1-1.148c.06-.201.16-.388.292-.548.132-.16.294-.29.476-.381.182-.092.38-.143.581-.15Z"
        fill="#46AED2"
      />
      <path
        d="M22.22 21.926c-.377 1.423-1.687 1.549-2.471 1.488a1.58 1.58 0 0 1-.154-.522 1.563 1.563 0 0 1 .287-1.11c.232-.317.574-.525.951-.579.572-.075 1.107.229 1.386.723Z"
        fill="#2F4572"
      />
      <path
        d="M20.639 22.415a.433.433 0 0 1-.086.304.403.403 0 0 1-.265.152.383.383 0 0 1-.292-.081.418.418 0 0 1 .052-.684.383.383 0 0 1 .148-.049.382.382 0 0 1 .292.082.418.418 0 0 1 .15.274v.002Zm1.322.37c.08.038.033.512-.287.73-.282.193-.697.126-.715.043-.015-.061.19-.104.514-.348.34-.258.433-.453.49-.425"
        fill="#B1ECED"
      />
      <path
        d="M24 20.24c.024.089-.563.38-1.188.518-1.015.225-1.993.013-1.99-.103-.002-.055.645-.14 1.942-.315 1.04-.138 1.223-.148 1.235-.1Z"
        fill="#296ABD"
      />
      <path
        d="M15.842 21.728c-.03-.02-.752-.477-1.274-1.48-.48-.92-.878-2.49-.056-4.756l.39.145c-.613 1.69-.605 3.167.024 4.388.47.912 1.13 1.336 1.136 1.34l-.22.363Z"
        fill="#5FBBE8"
      />
      <path
        d="M16.033 15.25a1.139 1.139 0 0 1-.364.758 1.037 1.037 0 0 1-.767.273 1.006 1.006 0 0 1-.399-.102 1.048 1.048 0 0 1-.33-.256 1.105 1.105 0 0 1-.21-.37 1.146 1.146 0 0 1-.058-.426c.021-.293.152-.565.364-.758.212-.194.488-.291.768-.273.138.007.273.041.398.103.125.062.237.148.33.256.093.107.164.232.21.369.046.136.065.281.058.426Z"
        fill="#294F81"
      />
      <path
        d="M14.428 14.98c.033.302.299.514.592.477a.524.524 0 0 0 .353-.205.557.557 0 0 0-.088-.771.51.51 0 0 0-.39-.11.512.512 0 0 0-.354.204.565.565 0 0 0-.114.406Z"
        fill="#296ABD"
      />
      <path
        d="M24.585 28.397c-.677.104-1.25-.144-1.692-.509-.795-.655-1.164-1.692-.949-1.75.337-.088 1.232.345 2.153.202 1.058-.162 1.727-.638 2.266-.752a.948.948 0 0 1 .07-.013c.553-.087.23 2.502-1.846 2.822"
        fill="#294F81"
      />
      <path
        d="M24.662 28.395c-.656.102-1.212-.147-1.64-.513.867-.307 2.55-1.036 3.353-2.296a.914.914 0 0 1 .068-.012c.533-.086.227 2.504-1.783 2.82"
        fill="#33487A"
      />
      <path
        d="m31.317 15.412-1.66-.373a.413.413 0 0 1-.318-.503l.589-2.29a.44.44 0 0 1 .526-.311l1.66.373a.412.412 0 0 1 .318.504l-.589 2.289a.44.44 0 0 1-.526.311Z"
        fill="#9FBFD9"
      />
      <path
        d="M34.583 9.251c-.09.37-.253.715-.48 1.014a2.596 2.596 0 0 1-.835.717.84.84 0 0 0-.267.233.886.886 0 0 0-.153.327l-.234 1.001a.87.87 0 0 1-.375.534.797.797 0 0 1-.624.104l-1.603-.398a.799.799 0 0 1-.291-.14.84.84 0 0 1-.218-.246.883.883 0 0 1-.097-.651l.235-1a.9.9 0 0 0-.126-.694 2.7 2.7 0 0 1-.425-1.032 2.774 2.774 0 0 1 .023-1.126c.346-1.476 1.85-2.37 3.361-1.994 1.51.374 2.454 1.875 2.109 3.351Z"
        fill="#FFE06D"
      />
      <path
        d="M32.536 5.631a3.16 3.16 0 0 0-2.31.324 2.85 2.85 0 0 0-1.375 1.803c-.097.396-.106.81-.025 1.21.077.387.232.753.464 1.086a.557.557 0 0 1 .085.46l-.236.965a1.139 1.139 0 0 0 .132.836c.074.123.172.228.286.31.114.083.243.14.38.17l1.602.38a1.104 1.104 0 0 0 1.32-.812l.235-.966a.594.594 0 0 1 .106-.219.56.56 0 0 1 .183-.153c.359-.193.666-.447.915-.758.37-.46.585-1.033.612-1.632a2.797 2.797 0 0 0-.465-1.679 3.119 3.119 0 0 0-1.909-1.326v.001Zm-.06.255c1.51.359 2.454 1.806 2.105 3.233a2.6 2.6 0 0 1-1.32 1.675.819.819 0 0 0-.266.223.865.865 0 0 0-.155.318l-.236.967a.876.876 0 0 1-.383.52.803.803 0 0 1-.62.098L30 12.54a.766.766 0 0 1-.289-.128.805.805 0 0 1-.218-.237.847.847 0 0 1-.1-.637l.237-.966a.842.842 0 0 0-.125-.67 2.526 2.526 0 0 1-.423-.994c-.07-.36-.06-.732.024-1.09.35-1.426 1.857-2.291 3.37-1.932Z"
        fill="#FFB455"
      />
      <path
        d="m32.072 13.74-2.451-.481c-.065-.012-.104-.067-.087-.122.016-.055.081-.09.144-.077l2.452.481c.064.012.103.068.087.122-.017.055-.082.09-.145.077Zm.037.819-2.452-.482c-.064-.011-.103-.067-.087-.123.017-.054.082-.09.145-.076l2.452.482c.064.011.103.067.086.121-.016.056-.081.091-.144.078Zm-.254.287-2.452-.481c-.063-.012-.102-.068-.087-.123.017-.054.082-.09.145-.076l2.451.48c.065.013.104.068.087.122-.016.056-.08.091-.144.078Z"
        fill="#779AB6"
      />
      <path
        d="M31.85 9.57a1.92 1.92 0 0 1-1.182-.813.093.093 0 0 1 .033-.133.102.102 0 0 1 .14.03c.087.139.428.601 1.084.736a1.82 1.82 0 0 0 1.27-.211.102.102 0 0 1 .139.032.095.095 0 0 1-.035.133 2.04 2.04 0 0 1-1.45.226Zm-1.737 2.63c-.078-.011-.125-.066-.104-.12l.45-1.192c.023-.055.103-.09.182-.079.079.011.126.065.106.12l-.453 1.192c-.02.055-.102.09-.18.079Z"
        fill="#FFFFB8"
      />
      <path
        d="M29.23 5.113a.133.133 0 0 1-.093-.068l-1.146-2.132c-.035-.065-.007-.144.064-.178a.143.143 0 0 1 .189.057l1.146 2.132c.035.065.006.144-.063.178a.15.15 0 0 1-.097.011Zm2.654-.691a.128.128 0 0 1-.069-.045.138.138 0 0 1-.028-.079l-.12-2.453a.133.133 0 0 1 .12-.142.13.13 0 0 1 .134.126l.122 2.455a.14.14 0 0 1-.045.11.127.127 0 0 1-.111.03l-.003-.002Zm1.877.444a.129.129 0 0 1-.075-.05.128.128 0 0 1-.021-.096.131.131 0 0 1 .017-.047l1.255-1.996a.131.131 0 0 1 .081-.058.125.125 0 0 1 .097.018c.06.036.078.117.038.177L33.9 4.81a.133.133 0 0 1-.061.051.125.125 0 0 1-.079.005h.002ZM35.696 6.4a.122.122 0 0 1-.051-.025.128.128 0 0 1-.01-.189.122.122 0 0 1 .04-.028l2.105-.951a.122.122 0 0 1 .096-.004.129.129 0 0 1 .073.167.128.128 0 0 1-.067.071l-2.105.95a.124.124 0 0 1-.081.009Z"
        fill="#FFB455"
      />
    </g>
    <defs>
      <clipPath id="IA_mascot_svg__a">
        <path fill="#fff" d="M0 0h40v40H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIaMascot;
